module.exports = __webpack_public_path__ + "img/Thailand Digital Arrival Card (TDAC)-th.234d010.png";